"use client"

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

export const screenContents: ReactNode = (
  <>
    <h2 className="text-xl font-bold mb-2">Kelebihan Sewa Screen Terdekat untuk Acara & Produksi Konten</h2>

    <h3 className="text-lg font-semibold mb-2">
      Sewa Screen Terdekat: Praktis, Fleksibel, Gak Perlu Beli
    </h3>

    <p className="mb-4">
      Mau tampil keren di event atau bikin konten visual yang niat? Gak perlu beli mahal, cukup <strong>sewa screen terdekat</strong>.
      Tersedia berbagai jenis screen: <strong>backdrop event</strong>, <strong>green screen</strong>, dan <strong>screen proyektor</strong>, semua bisa langsung kirim ke lokasi kamu.
    </p>

    <ul className="space-y-4 mb-6">
      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Beragam Jenis Screen Sesuai Kebutuhan</h4>
        <p className="text-sm">
          Butuh backdrop buat booth? Green screen untuk video? Atau layar besar buat proyektor?
          Tenang, semua tersedia. Kamu tinggal pilih dan langsung <strong>sewa screen dari lokasi terdekat</strong>.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Backdrop Event Standar hingga Custom Branding</h4>
        <p className="text-sm">
          Tersedia screen polos, black drop, white drop, hingga backdrop custom printing.
          Cocok buat seminar, konser, booth pameran, dan launching produk.
          Kami juga bisa bantu desain & pasang di tempat.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Green Screen Studio Lipat & Portable</h4>
        <p className="text-sm">
          Mau bikin video kreatif? <strong>Sewa green screen</strong> jadi solusi biar konten kamu lebih cinematic.
          Bisa untuk syuting YouTube, podcast, TikTok, atau produksi film pendek. Ukuran fleksibel, bisa digantung atau berdiri sendiri.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Screen Proyektor Ukuran Kecil Hingga Jumbo</h4>
        <p className="text-sm">
          Kami punya <strong>screen proyektor</strong> dari 70 inch sampai 200 inch. Cocok untuk presentasi, nobar, wedding,
          hingga outdoor movie night. Bisa lipat, roll, atau tripod stand. Ready pasang di indoor maupun outdoor.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Harga Sewa Screen Terdekat Terjangkau</h4>
        <p className="text-sm">
          Mulai dari sewa harian, mingguan, sampai langganan bulanan. <strong>Harga sewa screen terdekat</strong> bisa disesuaikan ukuran, jenis, dan kebutuhan event atau produksi kamu.
        </p>
      </li>
    </ul>

    <h2 className="text-xl font-bold mb-3">Support Setup & Bongkar Pasang di Area Terdekat</h2>
    <p className="mb-4">
      Untuk area sewa terdekat, kami bantu setup langsung ke lokasi. Mau backdrop nempel di truss, green screen dipasang di studio kecil, atau screen proyektor digelar outdoor, semua bisa, tinggal bilang.
    </p>

    <h2 className="text-xl font-bold mb-3">Kondisi Screen Terawat & Bebas Kerutan</h2>
    <p className="mb-4">
      Semua screen kami rawat rutin, dibersihkan, disimpan rapi, dan dicek sebelum kirim. Jadi gak bakal ketemu layar kusut, sobek, atau warnanya pudar.
    </p>

    <h2 className="text-xl font-bold mb-3">Sewa Screen Terdekat Bisa Dadakan</h2>
    <p className="mb-4">
      Butuh screen mendadak buat event hari ini? Selama unit masih ready, <strong>sewa screen terdekat</strong> bisa langsung dikirim hari yang sama.
      Cukup hubungi tim kami, tinggal tunggu tim instalasi datang ke lokasi.
    </p>

    <CTA
      title="Siap Tampilin Visualmu Bosku?"
      description="🚚 Butuh sewa screen terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Screen Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20screen.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ
      category="Screen"
    />


  </>
);
